import { forkJoin, of } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { map, mergeMap, tap } from 'rxjs/operators';
// NGRX
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
// Services
import { ConfigDebtService } from '../_services/';
// State
import { AppState } from '../../reducers';
// Actions
import {
	OneConfigDebtDeleted,
	ConfigDebtActionTypes,
	ConfigDebtCreated,
	ConfigDebtOnServerCreated,
	ConfigDebtsPageLoaded,
	ConfigDebtsPageRequested,
	ConfigDebtsPageToggleLoading,
	ConfigDebtUpdated
} from '../_actions/config-debt.actions';

@Injectable()
export class ConfigDebtEffects {
	showPageLoadingDistpatcher = new ConfigDebtsPageToggleLoading({isLoading: true});
	showLoadingDistpatcher = new ConfigDebtsPageToggleLoading({isLoading: true});
	hideActionLoadingDistpatcher = new ConfigDebtsPageToggleLoading({isLoading: false});

	// @Effect()
	// loadConfigDebtsPage$ = this.actions$
	// 	.pipe(
	// 		ofType<ConfigDebtsPageRequested>(ConfigDebtActionTypes.ConfigDebtsPageRequested),
	// 		mergeMap(({payload}) => {
	// 			this.store.dispatch(this.showPageLoadingDispatcher);
	// 			const requestToServer = this.configDebtService.findConfigDebts(payload.page);
	// 			const lastQuery = of(payload.page);
	// 			return forkJoin(requestToServer, lastQuery);
	// 		}),
	// 		map(response => {
	// 			const result: QueryResultsModel = response[0];
	// 			const lastQuery: QueryParamsModel = response[1];
	// 			return new ConfigDebtsPageLoaded({
	// 				ConfigDebts: result.items,
	// 				totalCount: result.totalCount,
	// 				page: lastQuery
	// 			});
	// 		}),
	// 	);

	// @Effect()
	// deleteConfigDebt$ = this.actions$
	// 	.pipe(
	// 		ofType<OneConfigDebtDeleted>(ConfigDebtActionTypes.OneConfigDebtDeleted),
	// 		mergeMap(({payload}) => {
	// 				this.store.dispatch(this.showLoadingDispatcher);
	// 				return this.configDebtService.deleteConfigDebt(payload.id);
	// 			}
	// 		),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// deleteConfigDebts$ = this.actions$
	// 	.pipe(
	// 		ofType<ManyConfigDebtsDeleted>(ConfigDebtActionTypes.ManyConfigDebtsDeleted),
	// 		mergeMap(({payload}) => {
	// 				this.store.dispatch(this.showLoadingDispatcher);
	// 				return this.configDebtService.deleteConfigDebts(payload.ids);
	// 			}
	// 		),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// updateConfigDebtsStatus$ = this.actions$
	// 	.pipe(
	// 		ofType<ConfigDebtsStatusUpdated>(ConfigDebtActionTypes.ConfigDebtsStatusUpdated),
	// 		mergeMap(({payload}) => {
	// 			this.store.dispatch(this.showLoadingDispatcher);
	// 			return this.configDebtService.updateStatusForConfigDebt(payload.ConfigDebts, payload.status);
	// 		}),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// updateConfigDebt$ = this.actions$
	// 	.pipe(
	// 		ofType<ConfigDebtUpdated>(ConfigDebtActionTypes.ConfigDebtUpdated),
	// 		mergeMap(({payload}) => {
	// 			this.store.dispatch(this.showLoadingDispatcher);
	// 			return this.configDebtService.updateConfigDebt(payload.ConfigDebt, payload.ConfigDebt.id); // TODO: fix this
	// 		}),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// createConfigDebt$ = this.actions$
	// 	.pipe(
	// 		ofType<ConfigDebtOnServerCreated>(ConfigDebtActionTypes.ConfigDebtOnServerCreated),
	// 		mergeMap(({payload}) => {
	// 			this.store.dispatch(this.showLoadingDispatcher);
	// 			return this.configDebtService.createConfigDebt(payload.ConfigDebt).pipe(
	// 				tap(res => {
	// 					this.store.dispatch(new ConfigDebtCreated({ConfigDebt: res}));
	// 				})
	// 			);
	// 		}),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// init$: Observable<Action> = defer(() => {
	//     const queryParams = new QueryParamsModel({});
	//     return of(new ConfigDebtsPageRequested({ page: queryParams }));
	// });

	constructor(private actions$: Actions, private configDebtService: ConfigDebtService, private store: Store<AppState>) {
	}
}
